export const ESTIMATED_WEIGHT_SCALE_ICON_SRC =
  '/assets/icons/estimated-weight-scale.svg';

export const ESTIMATED_WEIGHT_EMPTY_INTERSECTION_COPY =
  'Produk dalam pesanan ini tidak memiliki metode pembayaran reguler yang sama. Kembali ke Keranjang untuk menyesuaikan produk atau hubungi Bantuan.';

export const CHECKOUT_SELECT_PAYMENT_HELPER_COPY =
  'Pilih metode pembayaran terlebih dahulu';

export type EstimatedWeightOrderDetailStatus = 'pending' | 'confirmed';

export const ESTIMATED_WEIGHT_PENDING_STOCK_COPY = 'Menunggu konfirmasi stok';

export const ESTIMATED_WEIGHT_CONFIRMED_STOCK_COPY = 'Stok Terkonfirmasi';
